export default __webpack_public_path__ + "static/media/inner-digital-organization.edb2dd5a.svg";